<template>
	<div class="page">
		<Tip tip="子商城账户交易流水。" />
		<el-form :inline="true" :model="tableParams" class="condition">
            <el-form-item label="">
				<el-date-picker style="max-width:240px"
					v-model="tableParams.created_date"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					placeholder="选择时间范围"
					value-format="yyyy-MM-dd" >
				</el-date-picker>
            </el-form-item>
            <el-form-item label="">
                <el-select v-model="tableParams.shop_id" placeholder="请选择账户列表">
                    <el-option label="全部" :value="0"></el-option>
                    <el-option :label="item.shop_name" :value="item.shop_id" v-for="(item,index) in shopList" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-select v-model="tableParams.type" placeholder="请选择收支类型">
                    <el-option label="全部" :value="0"></el-option>
                    <el-option label="收入" :value="1"></el-option>
                    <el-option label="支出" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
				<el-input v-model="tableParams.order_no" placeholder="订单编号"></el-input>
            </el-form-item>
            <el-form-item label="">
				<el-input v-model="tableParams.subject" placeholder="摘要"></el-input>
            </el-form-item>
            <el-form-item label=" ">
                <el-button @click="initData({page:1})">筛选</el-button>
                <el-button type="warning" :loading="exportLoading" @click="onExport">{{exportLoading?'导出中':'导出'}}</el-button>
            </el-form-item>
        </el-form>
		<div class="static">
			合计：<span class="title">收入：</span>{{totalObj.income}}
			<span class="title">支出：</span>{{totalObj.outcome}}
			<span class="title">盈亏：</span>{{totalObj.profit}}
		</div>
		<div class="table" v-loading="tableLoading">
			<el-table :data="tableData" style="width: 100%" 
			:header-cell-style="{ background:'#e3e3e3',color:'#000',fontSize:'16px'}">
				<el-table-column prop="log_id" label="序号" width="100" align="center"></el-table-column>
				<el-table-column prop="shop_name" label="账户" align="center"></el-table-column>
				<el-table-column prop="order_no" label="业务订单" align="center"></el-table-column>
				<el-table-column prop="type_text" label="类型" align="center"></el-table-column>
				<el-table-column prop="amount" label="金额" align="center"></el-table-column>
				<el-table-column prop="subject_text" label="摘要" align="center"></el-table-column>
				<el-table-column prop="created_time" label="交易时间" align="center"></el-table-column>
				<!-- <el-table-column label="操作" align="center">
					<template  slot-scope="scope"><el-button type="primary" size="mini" @click="form={...scope.row,amount:1}">调额度</el-button></template>
				</el-table-column> -->
			</el-table>
			<div class="paging">
				<el-pagination background
						@size-change="initData({limit:$event})"
						:current-page.sync="tableParams.page"
						@current-change="initData({page:$event})"
						:page-size="tableParams.limit"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalNumber"></el-pagination>
			</div>
		</div>
		
        <el-dialog title="调额" width="500px" :visible="form.shop_id?true:false" destroy-on-close @close="form={}">
            <el-form :model="form" ref="upForm" label-width="100px" style="padding:0 30px 0 0">
                <el-form-item label="当前账户：">{{form.shop_name}}</el-form-item>
                <el-form-item label="调额类型：" prop="type" :rules="[{required: true,message: '请选择调额类型',trigger: 'blur'}]">
					<el-radio-group v-model="form.type" size="medium">
						<el-radio :label="1">收入</el-radio>
						<el-radio :label="2">支出</el-radio>
					</el-radio-group>
                </el-form-item>
                <el-form-item label="金额：" prop="amount" :rules="[{required: true,message: '请输入金额',trigger: 'blur'}]">
                    <el-input-number size="medium" :min="1" controls-position="right" placeholder="请输入金额" v-model="form.amount"/>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
					<el-input type="textarea" v-model="form.remark" rows="5"></el-input>
                </el-form-item>
                <div class="p-10"></div>
                <el-form-item>
                    <el-button @click="form={}">取消</el-button>
                    <el-button type="primary" class="but_blue" @click="onSubmit">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
    import {
		shopBalancelog,shopSelect,shopBalance
	} from "../../../request/apis.js"
	import base from "@/request/base.js"
	export default{
		components: {
			Tip
		},
		data(){
			return {
				shopLoad : false,
				tableData: [],
                tableParams : {
					limit: 10, // 每页显示条目个数
					page: 1, // 当前页数
					created_date : [],
					type : 0,
					order_no : '',
					subject : '',
					shop_id : 0
                },
				totalNumber:0,
				tableLoading : false,
				totalObj : {},
				shopList : [],
				form : {},
				exportLoading : false
			}
		},
		mounted(){
			this.initData();
			this.paramData();
		},
		methods:{
			paramData(){
                shopSelect().then(res => {
					this.shopList = res.data
				}).catch(err => {})
			},
			initData(params={}){
				for(var key in params){
					this.tableParams[key]	= params[key];
				}
				this.tableData    = [];
				this._getData()
			},
            _getData(){
                this.tableLoading = true;
                shopBalancelog(this.tableParams).then(res=>{
                    this.tableLoading = false;
                    this.tableData  = res.data||[];
                    this.totalNumber  = Number(res.count)||1;
					this.totalObj	= res.other.total||{};
                })
            },
			onExport(){
				this.exportLoading = true;
				var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
				window.location.href = `${base.url}/shop/balancelogexport?sid=${loginInfo.sid}&token=${loginInfo.token}&uid=${loginInfo.admin_id}`;
				setTimeout(()=>{
					this.exportLoading = false;
				},1000)
				// shopBalancelogexport().then(res=>{
				// 	this.exportLoading = false;
					
				// })
			},
			onSubmit(){
				this.$refs.upForm.validate((valid) => {
					if(valid){
						shopBalance(this.form).then(res=>{
							if(res.code===0){
								this.form = {};
								this.$message.success(res.msg||'调额成功')
								this.initData();
							}else{
								this.$message.warning(res.msg)
							}
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.flex{display: flex;justify-content: space-between;margin-top: 20px;}
	.block{padding: 20px 20px 30px;margin-bottom: 30px;box-shadow: 0 0 10px 0 #0000004f;border-radius: 16px;box-sizing: border-box;}
	.echarts{height: 300px;}
	.title{display: flex;justify-content: space-between;align-items: center;font-size: 22px;padding-left: 10px;font-weight: 500;margin-bottom: 15px;}
	.title_dec{font-size: 14px;color: #777;}
	.table{margin-top: 10px;}
	.paging{margin: 10px auto 50px;text-align: center;}
	.condition{margin-top: 20px;}
	.el-table::before{display: none;}
	.static{
		display: flex;font-size: 24px;margin-top: 10px;
	}
	.static span{margin-left: 20px;}
	.static span:first-child{margin-left: 0;}
</style>